export const CAR_DETAIL_FETCH_DATA_LOADING = 'CAR_DETAIL_FETCH_DATA_LOADING';
export const CAR_DETAIL_FETCH_DATA_SUCCESS = 'CAR_DETAIL_FETCH_DATA_SUCCESS';
export const CAR_DETAIL_FETCH_DATA_ERROR = 'CAR_DETAIL_FETCH_DATA_ERROR';
export const CAR_DETAIL_SET_PICKUP_TIME = 'CAR_DETAIL_SET_PICKUP_TIME';

export const CAR_PARAMS_SET_CONTEXT = 'CAR_PARAMS_SET_CONTEXT';
export const CAR_PARAMS_RESET_CONTEXT = 'CAR_PARAMS_RESET_CONTEXT';

export const SET_REWARD_OPTIONS_SUCCESS = 'SET_REWARD_OPTIONS_SUCCESS';
export const SET_REWARD_OPTIONS_ERROR = 'SET_REWARD_OPTIONS_ERROR';
